import Phaser from "phaser";

export class Projectile extends Phaser.Physics.Arcade.Image {
  private remainingLifeMs: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    angle: number,
    speed: number,
    lifeMs = 4200,
  ) {
    super(scene, x, y, texture);

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.remainingLifeMs = lifeMs;
    this.setDepth(2000);
    this.setRotation(angle);
    this.setBlendMode(Phaser.BlendModes.ADD);

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocity(Math.cos(angle) * speed, Math.sin(angle) * speed);
  }

  override update(delta: number): void {
    this.remainingLifeMs -= delta;
    if (this.remainingLifeMs <= 0) {
      this.destroy();
    }
  }
}
